import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import { LoadingButton } from '@mui/lab';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select, Slider, TextField } from '@mui/material';
import Image from 'components/Image';
import { useCallback, useState } from 'react';
import { postRequest } from 'utils/apiRequest';
import { getCarrierTypeOptions, getPickupTimes } from 'utils/functions';

const times = getPickupTimes();

export function ProductFulfillmentModal(props) {
    const { warehouses, carriers, warehouse, carrierId, fulfillmentLatencyHours, carrierType, pickupTime, afterSave = () => { } } = props;
    const [active, setActive] = useState(false);
    const [saving, setSaving] = useState(false);
    const [product, setProduct] = useState(props.product);
    const [fufillmentLatency, setFufillmentLatency] = useState(fulfillmentLatencyHours ?? 0);

    const [inventoryData, setInventoryData] = useState({
        product_id: product.id,
        warehouse_id: warehouse.id,
        carrier_id: carrierId ?? 1,
        fulfillment_latency_hours: fufillmentLatency ?? 0,
        type: carrierType,
        pickup_time: pickupTime.substring(0, 5),
    });

    const handleWarehouseSelectChange = (event) => {
        setInventoryData({ ...inventoryData, warehouse_id: parseInt(event.target.value) })
    }
    const handleCarrierSelectChange = (event) => {
        setInventoryData({ ...inventoryData, carrier_id: parseInt(event.target.value) });
    }
    const handleRangeSliderChange = (event, newValue) => {
        setFufillmentLatency(newValue)
        setInventoryData({ ...inventoryData, fulfillment_latency_hours: newValue })
    }
    const handleTypeSelectChange = (event) => {
        setInventoryData({ ...inventoryData, type: event.target.value })
    }
    const handlePickupTimeSelectChange = (event) => {
        setInventoryData({ ...inventoryData, pickup_time: event.target.value })
    }

    const carrierOptions = carriers.map((c, i) => {
        return { label: c.name, value: parseInt(c.id) }
    });
    const carrierTypeOptions = getCarrierTypeOptions();

    const handleOpen = useCallback(() => {
        setActive(true)
    });
    const handleSubmit = useCallback((data) => {
        setSaving(true);
        postRequest('/account/product/inventory/update', {
            productId: product.id,
            warehouseId: inventoryData.warehouse_id,
            fulfillmentLatencyHours: fufillmentLatency,
            carrierId: inventoryData.carrier_id,
            carrierType: inventoryData.type,
            // pickupTime: inventoryData.pickup_time
        }).then((d) => {
            // saved 

        }).finally(() => {
            afterSave().then(() => {
                setSaving(false);
                handleClose();
            })
        })
    });
    const handleClose = useCallback(() => setActive(!active), [active]);
    let activator = <Button onClick={handleOpen} variant="outlined"><EditTwoToneIcon /></Button>;

    let carrierUnchanged = carrierId == inventoryData.carrier_id;

    const MAX_DAYS = 10;
    const sliderMarks = [];
    for(let i = 0; i < MAX_DAYS; i++){
        sliderMarks.push(
            {
                name: i+' day',
                value: i*24
            })
    }

    return (<>{activator}
        <Dialog
            open={active}
            onClose={handleClose}
        >
            <DialogTitle>{warehouse.name} Fulfillment delay</DialogTitle>
            <DialogContent>
                <>
                    <>
                        <div style={{ display: 'flex' }}>
                            <div style={{ width: 100 }}>
                                <Image src={product.image_url} alt={product.name} width={75} height={75} />
                            </div>
                            <div style={{ marginTop: '1rem', display: 'grid', gap: '1rem', width: '100%', gridTemplateColumns: '1fr 1fr 1fr' }}>

                                <FormControl>
                                    <InputLabel>Carrier</InputLabel>
                                    <Select
                                        label="Carrier"
                                        name="carriers"
                                        onChange={handleCarrierSelectChange}
                                        value={inventoryData.carrier_id}>
                                        {carrierOptions.map((o, i) => {
                                            return <MenuItem key={i} value={o.value}>{o.label}</MenuItem>
                                        })}
                                    </Select>
                                </FormControl>
                                <FormControl>
                                    <InputLabel>Type</InputLabel>
                                    <Select
                                        label="Type"
                                        name="type"
                                        disabled={inventoryData.type !== null && carrierUnchanged}
                                        onChange={handleTypeSelectChange}
                                        value={inventoryData.type}>
                                        {carrierTypeOptions.map((o, i) => {
                                            return <MenuItem key={i} value={o.value}>{o.label}</MenuItem>
                                        })}
                                    </Select>
                                </FormControl>
                                {/* <FormControl>
                                    <TextField 
                                        readOnly
                                        disabled
                                        name="pickup_time"
                                        label="Pickup Time"
                                        defaultValue={inventoryData.pickup_time}
                                        />
                                </FormControl> */}
                            </div>
                        </div>
                        <br />
                        <div>
                            <InputLabel>{"Minumum fulfilment: " + Math.floor(fufillmentLatency / 24) + " days [" + fufillmentLatency + " hours]"}</InputLabel>
                            <Slider
                                onChange={handleRangeSliderChange}
                                aria-label={"Minumum fulfilment: " + Math.floor(fufillmentLatency / 24) + " days [" + fufillmentLatency + " hours]"}
                                defaultValue={inventoryData.fulfillment_latency_hours}
                                value={fufillmentLatency}
                                // valueLabelDisplay="auto"
                                step={6}
                                marks={sliderMarks}
                                min={0}
                                max={MAX_DAYS * 24}
                            />
                        </div>
                    </>
                </>
                <DialogActions>
                    <Button
                        variant="contained"
                        color="inherit"
                        onClick={()=>handleClose()}
                        >Close</Button>
                    <LoadingButton
                        variant="contained"
                        color="primary"
                        loading={saving}
                        onClick={()=>handleSubmit()}
                    >Save</LoadingButton>
                </DialogActions>
            </DialogContent>
        </Dialog>
    </>
    );
}
